import { InjectionToken } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import Highcharts from 'highcharts';
import 'highcharts/highcharts-more';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/no-data-to-display';
import 'highcharts/modules/offline-exporting';
import 'highcharts/modules/solid-gauge';

// weird highcharts fix : https://github.com/highcharts/highcharts/issues/20572
(function (H) {
  H.wrap(H.Point.prototype, 'pos', function (proceed) {
    if (!this.destroyed) {
      return proceed.apply(this, Array.prototype.slice.call(arguments, 1));
    }
  });
})(Highcharts);

export const ASSETS_HTTP_CLIENT = new InjectionToken<HttpClient>('HttpClient.assets');
